export const playNotificationSound = () => {
  const audioContext = new AudioContext();
  const oscillator = audioContext.createOscillator();
  const gainNode = audioContext.createGain();

  oscillator.connect(gainNode);
  gainNode.connect(audioContext.destination);

  // Higher frequency for a "ding" sound
  oscillator.type = "sine";
  oscillator.frequency.value = 1200;

  // Create a nicer envelope for the sound
  gainNode.gain.setValueAtTime(0, audioContext.currentTime);
  gainNode.gain.linearRampToValueAtTime(0.15, audioContext.currentTime + 0.02);
  gainNode.gain.linearRampToValueAtTime(0, audioContext.currentTime + 0.2);

  oscillator.start();
  oscillator.stop(audioContext.currentTime + 0.2);

  // Add a second tone for richness
  setTimeout(() => {
    const oscillator2 = audioContext.createOscillator();
    const gainNode2 = audioContext.createGain();

    oscillator2.connect(gainNode2);
    gainNode2.connect(audioContext.destination);

    oscillator2.type = "sine";
    oscillator2.frequency.value = 900;

    gainNode2.gain.setValueAtTime(0, audioContext.currentTime);
    gainNode2.gain.linearRampToValueAtTime(
      0.1,
      audioContext.currentTime + 0.02
    );
    gainNode2.gain.linearRampToValueAtTime(0, audioContext.currentTime + 0.15);

    oscillator2.start();
    oscillator2.stop(audioContext.currentTime + 0.15);
  }, 50);
};
